module.exports = __webpack_public_path__ + "img/addressLocation.03042383.svg";